import React from 'react';
import { Package, Truck, Bike, RotateCcw } from 'lucide-react';

const steps = [
  {
    icon: Package,
    title: 'Pick Gear',
    description: 'Select your helmet, jacket & gloves'
  },
  {
    icon: Truck,
    title: 'We Ship',
    description: 'Direct to your hotel or Airbnb'
  },
  {
    icon: Bike,
    title: 'You Ride',
    description: 'Enjoy premium protection on the road'
  },
  {
    icon: RotateCcw,
    title: 'Easy Return',
    description: 'Drop off at any UPS or FedEx'
  }
];

const HowItWorks = () => {
  return (
    <section className="py-20 px-6 md:px-12 bg-white" data-testid="how-it-works">
      <div className="max-w-[1200px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm text-[#C6A87C] uppercase tracking-widest mb-4 font-medium">
            Simple Process
          </p>
          <h2 className="font-['Barlow_Condensed'] text-4xl md:text-5xl font-bold uppercase tracking-tight text-[#1a1a1a]">
            How It Works
          </h2>
        </div>

        {/* Steps Grid - Perfectly Centered */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-4">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center w-full lg:w-1/4 relative"
              data-testid={`step-${index + 1}`}
            >
              {/* Connector Line - Only on desktop, between items */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[50%] w-full h-[2px] bg-gray-200 z-0"></div>
              )}
              
              {/* Step Number Badge */}
              <div className="absolute -top-3 z-20 w-7 h-7 bg-[#1a1a1a] text-white text-xs font-bold flex items-center justify-center rounded-sm shadow-md">
                {index + 1}
              </div>
              
              {/* Icon Container */}
              <div className="relative z-10 w-20 h-20 bg-white border-2 border-gray-200 flex items-center justify-center mb-5 hover:border-[#C6A87C] transition-colors duration-300">
                <step.icon className="w-9 h-9 text-[#1a1a1a]" strokeWidth={1.5} />
              </div>
              
              {/* Step Title */}
              <h3 className="font-['Barlow_Condensed'] text-xl font-bold uppercase tracking-tight mb-2 text-[#1a1a1a]">
                {step.title}
              </h3>
              
              {/* Step Description */}
              <p className="text-sm text-gray-600 max-w-[180px] leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
